<div *ngIf="!(networkService.isConnected$ | async)" class="offline-banner">
  No Internet Connection
</div>
<ion-router-outlet></ion-router-outlet>